<div class="dialog-container dialog-container--width">
    <div class="dialog-title-block">
        <h2>Update Password</h2>
        <div class="flex-container gap-2">
            <div class="dialog-btn" (click)="onClose()">
                <img class="dialog-colse-btn" src="../../../assets/images/close.png" alt="close">
            </div>
        </div>
    </div>
    <form #f="ngForm" name="form" (ngSubmit)="f.form.valid && submit(f.value)" novalidate>
        <div class="dialog-content-block p-4">
            <div class="mb-3">
                <p class="text-para text-grey-100">You are updating the password of “<span class="text-capitalize">{{ dialogData.fullName ? dialogData.fullName : '-' }}</span>”</p>
            </div>
            <div class="form-group">
                <h6 class="text-start text-heading-6 fw-normal text-light-dark mb-2">New Password *</h6>
                <input type="password" #new_password="ngModel" [(ngModel)]="formData.password" name="password" required>
                <div class="form-error-msg">
                    <div *ngIf="f.submitted && new_password.errors?.required">New password is required</div>
                </div>
            </div>
            <div class="form-group">
                <h6 class="text-start text-heading-6 fw-normal text-light-dark mb-2">Confirm Password *</h6>
                <input type="password" #confirm_password="ngModel" [(ngModel)]="formData.confirmPassword" name="confirm_password" required>
                <div class="form-error-msg">
                    <div *ngIf="f.submitted && confirm_password.errors?.required">Confirm password is required</div>
                    <div *ngIf="f.submitted && !confirm_password.errors?.required && formData.confirmPassword !== formData.password">Confirm password should be match with new password</div>
                </div>
            </div>
        </div>
        <div class="dialog-footer">
            <button class="px-4 py-2" type="button" (click)="onClose()">Cancel</button>
            <button class="px-4 py-2" type="submit">Update</button>
        </div>
    </form>
</div>

